import { makeStyles } from '@mui/styles'
import Colors from "../../../utils/Colors"

export default makeStyles(() => ({
  topBar: {
    display: 'flex',
    flexDirection: 'row',
    alignContent: "center",
    justifyContent: 'space-between',
    gap: '2vh',
  },

  container: {
    width: '100%',
    padding: '20px',
    marginBottom: '20px',
    marginTop: '20px',
    backgroundColor: '#fff',
    display: 'flex',
    flexDirection: 'column',
    alignContent: "baseline",
    gap: '2vh',
  },

  row: {
    display: 'flex',
    flexDirection: 'row',
    alignContent: "baseline",
    gap: '2vw',
  },

  actionButtonsRow: {
    display: 'flex',
    flexDirection: 'row',
    alignContent: "baseline",
    gap: '16px',
  },

  cancelButton: {
    backgroundColor: Colors.yellow,
    color: Colors.primaryColor,
    border: 'none',
    transition: 'background-color 0.3s ease-in-out',
    '&:hover': {
      backgroundColor: Colors.yellow,
      opacity: 0.5,
    },
  },

  formContainer: {
    width: '46vw',
  },

  checkContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: "flex-end",
    gap: '2vw',
  },

  inputLabel: {
    fontSize: '1.2rem',
  },
}))
